module.exports = __webpack_public_path__ + "media/images/icons/caret-bottom-b91fd4a6763d1c17bb88fb7f114e31b6.svg";